import { FC, useState } from 'react'
import { InputBase, Paper, InputBaseProps, useTheme } from '@mui/material'

import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const mobileScreenWidth = '767px'

export interface PasswordInputProps extends InputBaseProps {}

export const PasswordInput: FC<PasswordInputProps> = (props) => {
    const { error, ...rest } = props
    const theme = useTheme()
    const { t } = useTranslation()

    const [showPassword, setShow]: any = useState(false)

    return (
        <Paper
            sx={{
                padding: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: 400,
                fontSize: '18px',
                border: error ? 'solid 1px red' : 'solid 1px #d8d8dd',
                [`@media (max-width:${mobileScreenWidth})`]: {
                    width: 'auto',
                },
                '& .input': {
                    marginLeft: theme.spacing(1),
                    flex: 1,
                    fontSize: '20px',
                    color: theme?.palette?.grey?.[900],
                    width: '100%',
                    '& input::placeholder': {
                        fontSize: '18px',
                    },
                },
                '& .iconButtonText': {
                    margin: 0,
                    padding: 0,
                    color: theme?.palette?.grey?.[400],
                    fontSize: '10px',
                    marginBottom: '-4px',
                },
            }}
        >
            <IconButton size="large" tabIndex={-1} aria-hidden="true">
                <Icon
                    style={{ cursor: 'default' }}
                    name="Lock"
                    color="#D2D2D2"
                />
            </IconButton>
            <form
                name="masterPasswordInputForm"
                style={{ width: '100%' }}
                onSubmit={(e) => e.preventDefault()}
            >
                <InputBase
                    className={'input'}
                    placeholder={t('Common_MasterPassword')}
                    type={showPassword ? 'text' : 'password'}
                    inputProps={{
                        'aria-label': t('Common_MasterPassword'),
                        'aria-invalid': error ? true : undefined,
                    }}
                    {...rest}
                />
            </form>
            <IconButton
                sx={{ padding: '1rem' }}
                onClick={() => setShow((prev: any) => !prev)}
                onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter') {
                        e.preventDefault()
                        setShow((prev: any) => !prev)
                    }
                }}
                aria-label={showPassword ? t('Common_Hide') : t('Common_Show')}
                tabIndex={0}
                size="large"
            >
                <div>
                    <p className={'iconButtonText'}>
                        {showPassword ? t('Common_Hide') : t('Common_Show')}
                    </p>
                    <Icon name="View" color="#d2d2d2" />
                </div>
            </IconButton>
        </Paper>
    )
}
